export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_763_CLOSE': 'Close',
    '_11221_IMPORT_TRANSCRIPTS': 'Import Transcripts',
    '_11256_TRANSCRIPTS_FOR': 'Transcripts for',
    '_11257_SHOW_RESULTS': 'Show Results',
    '_11258_NO_TRANSCRIPTS_CAN_BE_FOUND_THAT_MATCH_THE_SELECTED_CRITERIA_': 'No transcripts can be found that match the selected criteria.',
    '_965_DATE': 'Date',
    '_9681_PARTICIPANTS': 'Participants',
    '_11259_MEETING_TITLE': 'Meeting Title',
    '_11260_TRANSCRIPT_IN_COMPAS': 'Transcript in Compas',
    '_11261_IMPORT_TO_COMPAS': 'Import to Compas',
    '_9297_YES': 'Yes',
    '_9298_NO': 'No',
    '_11262_UNKNOWN_USER': 'Unknown User',
    '_11263_TRANSCRIPT_IS_BEING_IMPORTED': 'Transcript is being imported',
    '__ONLY_TRANSCRIPTS_FROM_MICROSOFT_TEAMS_MEETINGS_': 'Only transcripts from Microsoft Teams meetings that are in your Microsoft calendar can be imported.',
    '__MICROSOFT_ACCOUNT_NOT_FOUND_': 'Microsoft account not found for the selected user.'
};
